import Notification from '../Notification/notification';

export default function NotificationBar({notifications, closeHandler}) {
    return (
        <div id="notificationBar">
            {notifications.map(n => <Notification key={n.msg} closeHandler={() => closeHandler(n.msg)} {...n} />)}
        </div>
    );
}